export const NOTES_PANEL_ID = 'notes-sidebar';
export const NOTES_SIDEBAR_WIDTH = 368; // same as HELP_PANEL_WIDTH
